import Rx from 'rxjs';
import moment from 'moment';
import { combineEpics } from 'redux-observable';

import { request } from 'core/generalFunctions';
import * as generalActions from 'modules/general/action';
import * as errorActions from 'modules/error/action';
import * as registrosActions from 'modules/registros/action';
import * as constAction from 'root/actionConstants';
import { minCronGet }  from 'core/constants';

const { ajax } = Rx.Observable;
var cronGetRegistrosInterval = false;

function cronGetRegistros(store){
  store.dispatch(registrosActions.get());
}

export const cronGetRegistrosEpic = (action$, store) =>
action$.ofType(constAction.REGISTROS_START_CRON)
.mergeMap(() => {
  cronGetRegistrosInterval = setInterval(
    cronGetRegistros,
    minCronGet,
    store
  );
  cronGetRegistros(store);
  return Rx.Observable.empty();
});

export const getRegistrosEpic = action$ =>
action$.ofType(constAction.REGISTROS_LOGS_CONCAT_STATE)
.throttleTime(120000)
.switchMap(({payload}) => {
  if(!Array.isArray(payload))
   return Rx.Observable.of(registrosActions.getLogs(moment(payload.fullDocument.fecha)));
  else return Rx.Observable.empty();
});

export const getEpic = (action$, store) =>
action$.ofType(constAction.REGISTROS_GET)
.switchMap(action =>
  ajax(request(action))
  .map(result => registrosActions.setState({ list: result.response }))
  .catch(err => errorActions.request(err, action))
  .startWith(generalActions.loadingbar_show())
  .finally(() => store.dispatch(generalActions.loadingbar_hide()))
);

export const getLogsEpic = (action$, store) =>
action$.ofType(constAction.REGISTROS_GET_LOGS)
.switchMap(action =>
  ajax(request(action))
  .map(result => registrosActions.concatState(result.response))
  .catch(err => errorActions.request(err, action))
  .startWith(generalActions.loadingbar_show())
  .finally(() => store.dispatch(generalActions.loadingbar_hide()))
);

export const getUserByIdEpic = (action$, store) =>
action$.ofType(constAction.REGISTROS_USER_BY_ID)
.switchMap(action =>
  ajax(request(action))
  .map(({response}) => registrosActions.setUserState(response))
  .catch(err => errorActions.request(err, action))
  .startWith(generalActions.loadingbar_show())
  .finally(() => store.dispatch(generalActions.loadingbar_hide()))
);

export default combineEpics(
  getUserByIdEpic,
  getLogsEpic,
  getEpic,
  cronGetRegistrosEpic,
  getRegistrosEpic
);



// WEBPACK FOOTER //
// src/modules/registros/epics.js